import React from 'react'
import Card from '../shared/card/card.jsx'
import ReactGA from 'react-ga'

let TipsCard = React.createClass({
  getInitialState: function () {
    return {
      tipNum: 0,
      tipsData: ''
    }
  },
  handleTipChange: function () {
    ReactGA.event({
      category: 'Yard Care Tips Next Tip Button',
      action: 'click',
      label: 'Yard Care Tips'
    })
    let newTipNum = this.state.tipNum
    newTipNum++
    let arrayLength = this.props.data.data.length
    if (newTipNum !== arrayLength) {
      this.setState({tipNum: newTipNum})
    } else {
      this.setState({tipNum: 0})
    }
  },
  render: function () {
    let header = 'Your Yard Care Tips'
    let subTitle, image, content
    if (this.props.data) {
      subTitle = this.props.data.data[this.state.tipNum].title
      image = '/common/latest/images/consumer/tip-card-images/' + this.props.data.data[this.state.tipNum].tipName + '.png'
      content = this.props.data.data[this.state.tipNum].content
    }

    return (
      <Card
        headerTitle={header}
        btnText='Next Tip'
        tempHeight='557px'
        btnStyle='btn btn-sm btn-info'
        btnOnClick={this.handleTipChange}>
        <h5 className='text-center' style={{paddingLeft: '30px', paddingRight: '30px'}}>{subTitle}</h5>
        <div style={{height: 234, width: 234, margin: 'auto', marginTop: 20, marginBottom: 20}}>
          <img style={{height: 234, width: 234}} src={image} alt='' />
        </div>
        <p style={{fontSize: 16}} className='text-left charcoal-gray-color' dangerouslySetInnerHTML={{ __html: content }} />
      </Card>
    )
  }
})

export default TipsCard



// WEBPACK FOOTER //
// ./src/components/dashboard/tips-card.jsx